module.exports = __webpack_public_path__ + "media/styles/images/png/arrow-down-gray-dark-09463e96fe847b4a05ace6de2090af33.png";